import React from "react";
import "./Orders.css";
import { Container, Row, Col, Modal, Button, Form } from "react-bootstrap";
import OrdersImg from "./../../Images/orders.png";
import { useState, useCallback } from "react";
import { useEffect } from "react";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import ConvertTime from "../../Common/ConvertTime";
import { useNavigate } from "react-router-dom";
import { fetchAllOrder } from "../../Actions/adminActions";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../Component/Pagination/PaginationControls";
import ExportExcel from "../../Component/ExportExcel/ExportExcel";
import moment from "moment";
import debounce from "lodash.debounce";
import apiCall from "../../API/API";

const PACKAGE_OPTIONS = [
  { packageId: 1, package_type: "8% (25 Months)" },
  { packageId: 2, package_type: "4% (20 Months)" },
  { packageId: 3, package_type: "3% (33 Months)" },
];

const Orders = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { orders } = useSelector((state) => state.admin);
  const [filter, setFilter] = useState("none");
  const [data, setData] = useState([]);
  const [search, setsearch] = useState({
    status: "",
    amount: "",
    username: "",
    search: "",
    packageId: "",
    startDate: "",
    endDate: "",
    uid: "",
    currentCycle: "",
    cycleDuration: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limitFilter, setLimitFilter] = useState(20);
  const [dateFilter, setDateFilter] = useState("default");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const fetchOrders = useCallback(
    debounce((params) => {
      dispatch(fetchAllOrder(params));
    }, 500),
    [dispatch]
  );

  const toggleFilter = () => {
    if (filter === "none") {
      setFilter("flex");
    } else {
      setFilter("none");
    }
  };
  const handlePagination = (page) => {
    // console.log("page",page)
    setCurrentPage(page);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    } else {
      setsearch((prev) => {
        const updatedSearch = { ...prev, [name]: value };
        Object.keys(updatedSearch).forEach((key) => {
          if (updatedSearch[key] === "" || updatedSearch[key] === 0) {
            delete updatedSearch[key];
          }
        });
        return updatedSearch;
      });
    }
    fetchOrders({
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
      ...(startDate && endDate ? { startDate, endDate } : {}),
    });
  };
  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };

  const handleDateFilterChange = (e) => {
    const value = e.target.value;
    setDateFilter(value);
    const today = moment().endOf("day");
    let start = "";
    let end = "";
    switch (value) {
      case "today":
        start = today.startOf("day").format("YYYY-MM-DD");
        end = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = today.subtract(1, "days").startOf("day").format("YYYY-MM-DD");
        end = today.endOf("day").format("YYYY-MM-DD");
        break;
      case "this_week":
        start = today.startOf("week").format("YYYY-MM-DD");
        end = today.endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        start = today.startOf("month").format("YYYY-MM-DD");
        end = today.endOf("month").format("YYYY-MM-DD");
        break;
      default:
        start = "";
        end = "";
        break;
    }
    setStartDate(start);
    setEndDate(end);
  };

  const Addfilter = () => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };

    if (startDate) {
      queryParams.startDate = startDate;
    }
    if (endDate) {
      queryParams.endDate = endDate;
    }

    dispatch(fetchAllOrder(queryParams));
  };

  const resetFilter = () => {
    const queryParams = {
      page: "1",
      limit: 20,
    };
    dispatch(fetchAllOrder(queryParams));
    setsearch({
      amount: "",
      username: "",
      search: "",
      packageId: "",
      startDate: "",
      endDate: "",
      status: "",
      uid: "",
      currentCycle: "",
      cycleDuration: "",
    });
    setLimitFilter(20);
    setStartDate("");
    setEndDate("");
    setDateFilter("default");
    setCurrentPage(1);
  };

  useEffect(() => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    if (startDate && endDate) {
      queryParams.startDate = startDate;
      queryParams.endDate = endDate;
    }
    fetchOrders(queryParams);
  }, [dispatch, currentPage, limitFilter, search, startDate, endDate]);

  useEffect(() => {
    setTotalRecords(orders?.totalRecords);
    setTotalPages(orders?.totalPages);
    // console.log("orders",orders)
  }, [orders]);

  const [totalRecord, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);

  const [revertModalOrder, setRevertModalOrder] = useState(null);
  const [revertReason, setRevertReason] = useState("");
  const [revertLoading, setRevertLoading] = useState(false);

  const isRevertEligible = (row) => {
    if (!row || row.type === "Upgrade_Infinity") return false;
    if (row.status !== 1) return false;
    if (!row.createdAt) return false;
    return Date.now() - new Date(row.createdAt).getTime() <= 60 * 60 * 1000;
  };

  const submitRevert = async () => {
    if (!revertModalOrder?.order_Id) return;
    setRevertLoading(true);
    try {
      const { data } = await apiCall(
        "POST",
        "/revert_package_order",
        {
          order_Id: revertModalOrder.order_Id,
          reason: revertReason.trim() || undefined,
        },
        true
      );
      if (data) {
        setRevertModalOrder(null);
        setRevertReason("");
        dispatch(
          fetchAllOrder({
            page: currentPage,
            limit: limitFilter,
            ...Object.fromEntries(
              Object.entries(search).filter(
                ([_, value]) => value !== "" && value !== 0
              )
            ),
            ...(startDate && endDate ? { startDate, endDate } : {}),
          })
        );
      }
    } finally {
      setRevertLoading(false);
    }
  };

  const handleExportExcel = async () => {
    try {
      const { data } = await apiCall(
        "GET",
        `/get_all_orders?limit=${totalRecord}`,
        null,
        false
      );

      setExportData(data?.data);

      // console.log("export excel response", data?.data);
      // toast.success("Excel file has been downloaded!");
    } catch (error) {
      // toast.error("Failed to export data");
    }
  };
  useEffect(() => {
    handleExportExcel();
  }, []);

  return (
    <React.Fragment>
      <Container className="orders-page">
        <div className="orders-head">
          <div>
            <p>Home / Orders</p>
            <h1>Orders</h1>
          </div>
          <div>
            <ExportExcel
              data={exportData}
              columns={[
                "name",
                "username",
                "uid",
                "amount",
                "source",
                "package_type",
                "tx_Id",
                "createdAt",
                "status",
              ]}
              fileName="orders.xlsx"
            />
          </div>
        </div>
        <section className="orders-panel">
        <Row id="filterRow" className="g-0">
          <span
            id="filterLogo"
            className={filter === "flex" ? "is-open" : ""}
          >
            <div className="orders-filter-bar">
              <div
                className="orders-filter-toggle"
                onClick={() => toggleFilter()}
              >
                <i>
                  <BiFilter />
                </i>
                Filter
              </div>
              <div className="orders-total">
                Total Debited Amount : {orders?.Sum}
              </div>
            </div>
          </span>

          <Row className="p-0 m-0" style={{ display: filter }}>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  name="search"
                  placeholder="Search By Name, Username"
                  value={search.search}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  placeholder="Search User By Uid"
                  name="uid"
                  value={search.uid}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="number"
                  name="amount"
                  placeholder="Search By Amount"
                  value={search.amount}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="number"
                  placeholder="Current Cycle"
                  name="currentCycle"
                  value={search.currentCycle}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="number"
                  placeholder="Cycle Duration"
                  name="cycleDuration"
                  value={search.cycleDuration}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="packageId"
                  value={search.packageId}
                  onChange={handleChange}
                >
                  <option value="">Package Type</option>
                  {PACKAGE_OPTIONS.map((pkg) => (
                    <option key={pkg.packageId} value={String(pkg.packageId)}>
                      {pkg.package_type}
                    </option>
                  ))}
                </select>
              </div>
            </Col>
            {/*<Col lg="2" md="4">
              <div>
              
              <input type="text" name='username' placeholder="Search By UserName" value={search.username} onChange={handleChange} />
               </div>
            </Col>*/}
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="startDate"
                  placeholder="Start Date"
                  value={startDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="endDate"
                  placeholder="End Date"
                  value={endDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="dateFilter"
                  value={dateFilter}
                  onChange={handleDateFilterChange}
                >
                  <option value="default">Default</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name=""
                  value={limitFilter}
                  onChange={handleLimitChange}
                >
                  <option value="">--All--</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
            </Col>
            <div className="orders-filter-actions">
              <button className="save filter" onClick={Addfilter}>
                Filter{" "}
                <i>
                  <BiFilter />
                </i>
              </button>
              <button className="cancel reset" onClick={resetFilter}>
                Reset{" "}
                <i>
                  <GrPowerReset />
                </i>
              </button>
            </div>
          </Row>
        </Row>
        <div id="directIncomeDiv">
          {/*<div id="ordersImg"><img src={OrdersImg} alt="" /></div>*/}

          <Row id="directTableRow" className="">
            <Col md="12" className="p-0">
              <div style={{ width: "100%" }}>
                <table>
                  <thead>
                  <tr>
                    <th>S No.</th>
                    <th>Name</th>
                    <th>Username</th>
                    <th>Uid</th>
                    <th>Amount</th>
                    <th>Transaction Type</th>
                    <th>Package Type</th>
                    {/* <th>Current Cycle</th>
                    <th>Cycle Duration</th> */}
                    <th>Transaction Id</th>
                    <th>Package Date&Time</th>
                    <th>Package Status</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  {orders?.data?.map((x, i) => {
                    return (
                      <tr key={x?.order_Id ?? i}>
                        <td>{i + 1 + limitFilter * (currentPage - 1)}</td>
                        <td>{x?.name}</td>
                        <td className="orders-user">{x?.username}</td>
                        <td className="orders-uid">{x?.uid}</td>
                        <td className="orders-amount">{x?.amount}</td>
                        <td>
                          {x?.source
                            ? x.source
                                .split("_")
                                .join(" ")
                                .replace(/^./, (char) => char.toUpperCase())
                            : "N/A"}{" "}
                          {/* If x.source is undefined or null, display "N/A" */}
                        </td>
                        <td>{x?.package_type}</td>
                        {/* <td>{x?.currentCycle}</td>
                        <td>{x?.cycleDuration}</td> */}
                        <td>
                          {x?.tx_Id === 0 ? (
                            "Pending"
                          ) : x?.source === "dap" ? (
                            <a
                              href={`https://bscscan.com/block/${x?.tx_Id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <u>{x?.tx_Id}</u>
                            </a>
                          ) : (
                            x?.tx_Id
                          )}
                        </td>
                        <td className="orders-date">
                          {moment(x?.createdAt).format(
                            "MM-DD-YYYY   &   HH:mm"
                          )}
                        </td>
                        <td>
                          <span
                            className={`orders-status ${
                              x?.status === 1
                                ? "orders-status--approved"
                                : x?.status === 4
                                  ? "orders-status--reverted"
                                  : "orders-status--pending"
                            }`}
                          >
                            {x?.status === 1
                              ? "Approved"
                              : x?.status === 4
                                ? "Reverted"
                                : "Pending"}
                          </span>
                        </td>
                        <td>
                          {isRevertEligible(x) ? (
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => {
                                setRevertReason("");
                                setRevertModalOrder(x);
                              }}
                            >
                              Revert
                            </Button>
                          ) : (
                            "—"
                          )}
                        </td>
                      </tr>
                    );
                  })}
                  </tbody>
                </table>
              </div>
          </Col>
        </Row>
        </div>
        </section>
        <Row className="orders-pagination">
          <Col md="12">
            {
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePagination}
              />
            }
          </Col>
        </Row>

        <Modal
          show={!!revertModalOrder}
          onHide={() => !revertLoading && setRevertModalOrder(null)}
          centered
        >
          <Modal.Header closeButton={!revertLoading}>
            <Modal.Title>Revert package order</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="small text-muted mb-2">
              Only allowed within 30 minutes of purchase. User-funded orders
              refund the payer wallet; admin activation orders reverse team /
              binary only.
            </p>
            {revertModalOrder && (
              <p className="mb-2">
                <strong>Order</strong> #{revertModalOrder.order_Id} —{" "}
                {revertModalOrder.username} — {revertModalOrder.amount}
              </p>
            )}
            <Form.Group className="mb-2">
              <Form.Label>Reason (optional)</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={revertReason}
                onChange={(e) => setRevertReason(e.target.value)}
                disabled={revertLoading}
                placeholder="Note for audit log"
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setRevertModalOrder(null)}
              disabled={revertLoading}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={submitRevert}
              disabled={revertLoading}
            >
              {revertLoading ? "Working…" : "Confirm revert"}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </React.Fragment>
  );
};

export default Orders;
